<template>
  <div class="notranslate" translate="no">
    <div class="row">

      <div class="col-md-5">

        <div class="form-group">
          <label class="col-sm-3 control-label">Type of search</label>
          <div class="col-sm-9">
            <select v-model="searchTypeSelected" class="m-b form-control">
              <option v-for="(type, key) in searchType" :key="key">{{type}}</option>
            </select>
          </div>
        </div>
        <div v-if="searchTypeSelected === 'Keywords'" class="text-left">
          <div class="form-group">
            <label class="col-sm-3 control-label">Exact phrase</label>
            <div class="col-sm-9">
              <input type="text" class="form-control" v-model="advancedSearch.phrase.data" :disabled="!advancedSearch.phrase.enable">
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">All keywords</label>
            <div class="col-sm-9">
              <input type="text" class="form-control" v-model="advancedSearch.and.data" :disabled="!advancedSearch.and.enable">
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">Any keywords</label>
            <div class="col-sm-9">
              <input type="text" class="form-control" v-model="advancedSearch.or.data" :disabled="!advancedSearch.or.enable">
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 control-label">Excluded</label>
            <div class="col-sm-9">
              <input  class="form-control" type="text" v-model="advancedSearch.not.data" :disabled="!advancedSearch.not.enable">
            </div>
          </div>
        </div>

        <div v-else-if="searchTypeSelected === 'Name'">
          <template v-if="documentType === 'science'">
            <div class="form-group">
              <label class="col-sm-3 control-label">Last Name</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" v-model="advancedSearchName.lastName">
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">First Name</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" v-model="advancedSearchName.firstName">
                <span class="help-block m-b-none"> Tip : also try using initials for First Name</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="form-group">
              <label class="col-sm-3 control-label" v-if="documentType === 'company'">Company Name</label>
              <label class="col-sm-3 control-label" v-else>Applicant Name</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" v-model="advancedSearchName.lastName">
              </div>
            </div>
          </template>
        </div>

      </div>
      <div class="col-md-7">

        <div class="row">

          <div class="form-group">
            <label class="col-sm-3 control-label">Document Type</label>
            <div class="col-sm-5">
              <document-type-dropdown :buttonStyle="'width:100%'" :buttonClass="'btn-sm'" v-model="documentType"/>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 15px">
          <div class="col-xs-7">
            <div class="form-group"><label class="col-sm-5 control-label">Counts</label>
              <div class="col-sm-7">
                <select v-model="countFilterSelected" class="form-control">
                  <option v-for="(type, key) in countType" :key="key">{{type}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-xs-5">
            <div class="form-group"><label class="col-sm-4 control-label">Suggestions</label>
              <div class="col-sm-8">
                <select v-model="suggestionsFilterSelected" class="form-control">
                  <option v-for="(suggestion, key) in suggestionsFilter" :key="key">{{suggestion}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 15px">
          <div class="form-group">
            <label class="col-sm-3 control-label">Cloud Source</label>
            <div class="col-sm-9" id="cloudSources">
              <div class="checkbox checkbox-info checkbox-inline" v-for="(source, key) in sources" :key="key">
                <template v-if="(source.label === 'c6' || source.label === 'c7' || source.label === 'c8') && !$auth.check('super_admin')"></template>
                <template v-else>
                  <input type="checkbox" :id="source.label" v-model="source.checked" :disabled="documentType !== 'science'">
                  <template v-if="$user.isOrange() || $user.isSafran() || $user.isBicWorld() || $user.isGAC()">
                    <label class="" :for="source.label" data-toggle="popover" :data-content="source.details"> {{source.name}}</label>
                  </template>
                  <template v-else>
                    <label class="" :for="source.label"> {{source.name}}</label>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 15px">
          <div class="form-group" id="rangeDate">

            <label class="col-sm-3 control-label" style="font-weight: bold">Date</label>

            <div class="col-sm-9 ">

              <div class="">
                <div class="col-xs-12 col-sm-6" style="padding: 0">
                  <label class="col-xs-4 control-label text-right inline-label">From :</label>
                  <div class="col-sm-8 col-xs-5">
                    <div class="input-group">
                      <input type="text" class="form-control" placeholder="2000" v-model="date.from">
                      <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6" style="padding: 0">
                  <label class="col-xs-4 control-label text-right inline-label">To :</label>
                  <div class="col-sm-8 col-xs-5">
                    <div class="input-group">
                      <input type="text" class="form-control" :placeholder="$moment().year()" v-model="date.to">
                      <span class="input-group-addon"><i class="fa fa-calendar"></i></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="row" style="margin-top: 15px">

          <div class="form-group">
            <label class="col-sm-3 control-label">Search Depth</label>
            <div class="col-sm-9" style="margin-top: 5px">

              <vue-slider ref="slider" v-model="rangeDocumentValue" v-show="showSlider"
                          :piecewise="true"
                          :piecewise-label="true"
                          :data="[120, 300, 400, 500]"
                          :sliderStyle="[{'backgroundColor': '#3498db'}, {'backgroundColor': '#3498db'}]"
                          :tooltipStyle="[{'backgroundColor': '#3498db', 'borderColor': '#3498db'}, {'backgroundColor': '#3498db', 'borderColor': '#3498db'}]"
                          :processStyle="{'backgroundColor': '#3498db'}"/>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 15px">
          <div class="form-group">
            <label class="col-sm-3 control-label">Countries</label>
            <div class="col-sm-9" style="margin-top: 5px">
              <div class="col-xs-12">
                <select2 v-if="showCountryFilter" :options="countries" label="name" v-model="countriesSelected"
                         :multiple="true" :placeholder="'Chose countries'" :searchable="true"></select2>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="text-center" style="margin-top: 20px">
      <vue-ladda type="submit" :loading="submitButton.loading" class="btn btn-outline btn-info" style="min-width: 200px" @click="submitSearch" :data-style="submitButton.dataStyle">Search</vue-ladda>
    </div>
  </div>
</template>

<style>
  #cloudSources .popover {
    width: 400px;
  }
</style>
<style lang="css" scoped>

  #rangeDate label {
    padding-top: 7px;
    font-weight: normal;
  }

  .range-slider-fill {
    background-color: #3498db;
  }

</style>
<script>
import VueLadda from 'vue-ladda'
import VueSlider from 'vue-slider-component'
import Select2 from '../utils/select2'
import DocumentTypeDropdown from './DocumentTypeDropdown'

export default {
  components: {
    VueLadda,
    VueSlider,
    Select2,
    DocumentTypeDropdown

  },
  name: 'Advanced',
  props: ['value', 'submitButton', 'defaultRangeDocumentValue', 'sources', 'defaultDocumentType', 'suggestionsFilter',
    'countType', 'searchType', 'showCountryFilter', 'showSlider', 'launchSearch'],
  watch: {
    showSlider (val) {
      if (val === true) {
        this.$nextTick(() => {
          this.$refs.slider.refresh()
          $('[data-toggle="popover"]').popover({
            trigger: 'hover',
            placement: 'top',
            html: true
          })
        }
        )
      }
    },
    'advancedSearch.phrase.data': function (data) {
      if (data.length !== 0) {
        this.advancedSearch.or.data = ''
        this.advancedSearch.or.enable = false
      } else if (this.advancedSearch.and.data.length === 0) {
        this.advancedSearch.or.enable = true
      }
    },
    'advancedSearch.and.data': function (data) {
      if (data.length !== 0) {
        this.advancedSearch.or.data = ''
        this.advancedSearch.or.enable = false
      } else if (this.advancedSearch.phrase.data.length === 0) {
        this.advancedSearch.or.enable = true
      }
    },
    'advancedSearch.or.data': function (data) {
      if (data !== null && data.length !== 0) {
        this.advancedSearch.and.data = ''
        this.advancedSearch.and.enable = false
        this.advancedSearch.phrase.data = ''
        this.advancedSearch.phrase.enable = false
      } else {
        this.advancedSearch.and.enable = true
        this.advancedSearch.phrase.enable = true
      }
    },
    countries: function (countries) {
      if (typeof this.$route.query._countries !== 'undefined') {
        let _countries = this.$route.query._countries
        this.countriesSelected = []
        countries.forEach((country) => {
          if (_countries.search(country.name) !== -1) {
            this.countriesSelected.push(country)
          }
        })
      }
    },
    documentType: function (val) {
      if (val !== 'science') {
        this.sources.forEach((source) => {
          source.checked = false
        })
      } else {
        this.sources.forEach((source) => {
          if (source.label === 'default') {
            source.checked = true
          }
        })
      }
    },
    value: function (value) {
      this.query = value
      this.queryToAdvancedSearch()
    }
  },
  data () {
    return {
      countries: [],
      query: '',
      documentType: null,
      rangeDocumentValue: 120,
      suggestionsFilterSelected: 'Filtered',
      searchTypeSelected: 'Keywords',
      countFilterSelected: 'Number of documents',
      countriesSelected: [],
      advancedSearch: {
        phrase: {
          data: '',
          enable: true
        },
        and: {
          data: '',
          enable: true
        },
        or: {
          data: '',
          enable: true
        },
        not: {
          data: '',
          enable: true
        }
      },
      advancedSearchName: {
        firstName: '',
        lastName: ''
      },
      date: {
        from: null,
        to: null
      }
    }
  },
  methods: {
    getQuery: function () {
      this.advancedSearchToQuery()
      return this.query
    },
    getDate: function () {
      return this.date
    },
    getSearchTypeSelected: function () {
      return this.searchTypeSelected
    },
    getCountFilterSelected: function () {
      return this.countFilterSelected
    },
    getSuggestionsFilterSelected: function () {
      return this.suggestionsFilterSelected
    },
    getRangeDocumentValue: function () {
      return this.rangeDocumentValue
    },
    getAdvancedSearchName: function () {
      return this.advancedSearchName
    },
    getDocumentType: function () {
      return this.documentType
    },
    submitSearch: function (e) {
      if (e !== null) {
        e.preventDefault()
      }
      this.advancedSearchToQuery()
      this.$emit('input', this.query)
      this.launchSearch(e)
    },
    advancedSearchToQuery: function () {
      let data = []

      if (this.searchTypeSelected === 'Keywords') {
        if (this.advancedSearch.phrase.data.length !== 0) {
          let phrase = this.advancedSearch.phrase.data.split(' ')

          let tmp = ''
          phrase.forEach((item) => {
            if (item.trim() === 'AND' || item.trim() === 'OR' || item.trim() === 'NOT') {
              data.push(tmp.trim())
              data.push(item)
              tmp = ''
            } else {
              tmp += ' ' + item
            }
          })

          if (tmp.length !== 0) {
            data.push(tmp.trim())
          }
        }

        if (this.advancedSearch.and.data.length !== 0) {
          let and = this.advancedSearch.and.data.replace(/ and /gi, ' ').split(' ')
          and.forEach((item) => {
            data.push(',' + item.trim())
          })
        }

        if (this.advancedSearch.or.data.length !== 0) {
          let or = this.advancedSearch.or.data.replace(/ or /gi, ' ').split(' ')
          or.forEach((item) => {
            data.push('OR,' + item.trim())
          })
        }

        if (this.advancedSearch.not.data.length !== 0) {
          let not = this.advancedSearch.not.data.replace(/ not /gi, ' ').split(' ')
          not.forEach((item) => {
            data.push('NOT,' + item.trim())
          })
        }
      } else if (this.searchTypeSelected === 'Name' && this.advancedSearchName.lastName.length !== 0) {
        let searchName = ''
        if (this.advancedSearchName.firstName.length !== 0) {
          searchName = this.advancedSearchName.firstName.trim()
        }
        searchName += ' ' + this.advancedSearchName.lastName.trim()
        data.push('name:"' + searchName.trim() + '"')
      }
      if (data.length) data[0] = data[0].replace('NOT,', '').replace('AND,', '').replace('OR,', '')

      this.query = data.join(',')
    },
    queryToAdvancedSearch: function () {
      if (this.query !== null && this.query.length) {
        let query = this.query.split(',')
        let prevTag = null
        let and = []
        let or = []
        let not = []
        let phrase = []

        let nameRegex = /name:"(.*)"/gm
        let queryName = nameRegex.exec(this.query)
        if (queryName !== null) {
          this.searchTypeSelected = this.searchType[1]

          if (this.documentType === 'science') {
            let names = queryName[1].split(' ')
            this.advancedSearchName.lastName = names[names.length - 1]
            delete names[names.length - 1]
            this.advancedSearchName.firstName = ''
            if (names.length !== 0) {
              names.forEach((firstName) => {
                if (this.advancedSearchName.firstName.length === 0) {
                  this.advancedSearchName.firstName = firstName
                } else {
                  this.advancedSearchName.firstName += ' ' + firstName
                }
              })
            }
          } else {
            this.advancedSearchName.lastName = queryName[1]
            this.advancedSearchName.firstName = ''
          }
        } else {
          this.searchTypeSelected = this.searchType[0]
          query.forEach((tag) => {
            if (prevTag !== null && (prevTag.toLowerCase() === 'and' || prevTag.toLowerCase() === 'or' || prevTag.toLowerCase() === 'not')) {
              if (prevTag.toLowerCase() === 'and') {
                if (tag.match(/"[\w\s]+"/g) !== null || (tag.match(/[\w]+/gm) !== null && tag.match(/[\w]+/gm).length > 1)) {
                  phrase.push(tag.trim())
                } else {
                  and.push(tag.trim())
                }
              } else if (prevTag.toLowerCase() === 'or') {
                if (tag.match(/"[\w\s]+"/g) !== null || (tag.match(/[\w]+/gm) !== null && tag.match(/[\w]+/gm).length > 1)) {
                  phrase.push('OR')
                  phrase.push(tag.trim())
                } else {
                  or.push(tag.trim())
                }
              } else if (prevTag.toLowerCase() === 'not') {
                not.push(tag.trim())
              }
            } else if (tag.toLowerCase() !== 'and' && tag.toLowerCase() !== 'or' && tag.toLowerCase() !== 'not') {
              if (tag.match(/"[\w\s]+"/gm) !== null || (tag.match(/[\w]+/gm) !== null && tag.match(/[\w]+/gm).length > 1)) {
                phrase.push(tag.trim())
              } else {
                and.push(tag.trim())
              }
            }
            prevTag = tag
          })

          this.advancedSearch.and.data = ''
          this.advancedSearch.or.data = ''
          this.advancedSearch.not.data = ''
          this.advancedSearch.phrase.data = ''
          and.forEach((item, key) => {
            if (or.length !== 0) {
              this.advancedSearch.or.data += (key !== 0 ? ' ' + item : item)
            } else {
              this.advancedSearch.and.data += (key !== 0 ? ' ' + item : item)
            }
          })

          or.forEach((item, key) => {
            this.advancedSearch.or.data += (this.advancedSearch.or.data !== '' ? ' ' + item : item)
          })

          not.forEach((item, key) => {
            this.advancedSearch.not.data += (key !== 0 ? ' ' + item : item)
          })

          phrase.forEach((item, key) => {
            this.advancedSearch.phrase.data += (key !== 0 ? ' AND ' + item.replace(/['"]+/g, '') : item.replace(/['"]+/g, ''))
          })
          this.advancedSearch.phrase.data = this.advancedSearch.phrase.data.replace(' AND OR AND ', ' OR ')
        }
      }
    },
    getResources: function () {
      this.axios.get('/countries')
        .then((response) => {
          this.countries = response.data
        })
        .catch(function (error) {
        })
    },
    getCountriesSelected: function () {
      let countries = []
      if (this.countriesSelected.length !== 0) {
        this.countriesSelected.forEach((countrySelected) => {
          countries.push(countrySelected.name)
        })
      }
      return countries
    }
  },
  beforeMount () {
    this.query = this.value
    this.documentType = this.defaultDocumentType
    this.rangeDocumentValue = this.defaultRangeDocumentValue
    if (typeof this.$auth.user().id !== 'undefined') {
      this.getResources()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/search/Advanced.vue